import React from 'react'
import SimpleFormat from '../simpleFormatter/SimpleFormatter'
import { ReadMoreLegacy } from 'ui/acro'

import PropTypes from 'prop-types'

const ItemTileDescription = props => {
  return (
    <div className='product-description read-more'>
      <ReadMoreLegacy initialHeight={68} noReadMoreHeightCompensator={17}>
        <SimpleFormat text={props.description} />
      </ReadMoreLegacy>
    </div>
  )
}

ItemTileDescription.propTypes = {
  description: PropTypes.string
}

export default ItemTileDescription
